<div class="cargando" *ngIf="cargando" fxLayout="row" fxLayoutAlign="center center">
  <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
</div>

<div fxLayout="column" fxLayoutAlign="center center">
<mat-card class="mat-elevation-z5" *ngIf="!cargando" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
<div fxLayout="column" fxLayoutAlign="center center">
    <div class="mt-20 mb-20">
      <h2 class="mt-0">{{'CERTIFICAR.COLABORADORES.CARD_BD.TITULO' | translate}}</h2>
      <mat-divider id="matDiver"></mat-divider>
      <div class="h4 secondary-text">{{'CERTIFICAR.COLABORADORES.CARD_BD.NUMCOLABS' | translate}}</div>
      <div class="font-size-54 font-weight-300 line-height-1 mt-8">{{colabsEnBD | number:'.0'}}</div>
      <mat-divider id="matDiver"></mat-divider>
    </div>

    <div class="mt-10">
      <div class="h4 secondary-text">{{'CERTIFICAR.COLABORADORES.CARD_BD.FECHA' | translate}}</div>
      <div class="font-size-24 font-weight-300 line-height-1 mt-8">{{fechaCarga |date:"fullDate":'':idiomaActual}}</div>
    </div>

    <div class="mt-20">
    <mat-divider id="matDiver"></mat-divider>
    <div class="h4 secondary-text">{{'CERTIFICAR.COLABORADORES.CARD_BD.BOTONES.DESCARGA' | translate}}</div>
    <div fxLayout="row" fxLayoutAlign="center center" >
    <button mat-fab class="mb-20 primary" (click)="descargaExcel()">
      <mat-icon>cloud_download</mat-icon>
    </button>
    </div>
    </div>

</div>
</mat-card>
</div>
